<template>
  <hr class="divider" />
</template>

<script>
export default {
  name: 'QDivider',
};
</script>

<style lang="scss" scoped>

.divider {
  align-self: stretch;
  border: 1px solid var(--color-neutral-gray-lighter);
  height: auto;
  width: auto;
}
</style>
